import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  margin-bottom: 20px;
`;
const Wrapper = styled.div`
  min-height: 150px;
  box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
  border-radius: 5px;
  border: none !important;
  background-color: ${COLORS.WHITE};
`;
const Heading = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${COLORS.BODY_TEXT};
  font-weight: 600;
  padding: 10px 15px;
  justify-content: space-between;
`;

const Panel = styled.div`
  padding: 15px;
`;
const OrderInfo = styled.ul`
  padding: 0;
  margin: 0;
  li {
    display: grid;
    column-gap: 20px;
    margin-bottom: 12.5px;
    @media (min-width: 470px) {
      grid-template-columns: 0.3fr 1fr;
    }
    span {
      line-height: 1.42857143;
      :first-child {
        width: auto;
        font-weight: 700;
        @media (min-width: 768px) {
          float: left;
          width: 160px;
          overflow: hidden;
          clear: left;
          text-align: right;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        @media (min-width: 992px) {
          min-width: 99px;
        }
      }
    }
  }
`;

const Status = styled.div`
  flex-direction: column;
  position: relative;
  justify-content: center;
  border-radius: 4px;
  padding: 3px 12.5px;
  border: 1px solid #ff6600;
  color: #ff6600;
  height: 36px;
  width: auto;
  min-width: 175px;
  text-align: center;
  display: inline-flex;
  flex: 0;
  box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #fff;
  h5 {
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: bold;
    margin: 0;
    font-size: 11px;
    color: inherit;
  }
  &.awaiting {
    color: #ff6600;
    border-color: #ff6600;
  }
  &.pending-details {
    color: #ffae18;
    border-color: #ffae18;
  }
  &.shipped {
    color: green;
    border-color: green;
  }
  &.cancelled {
    color: red;
    border-color: red;
  }
  span {
    font-size: 12px;
  }
`;

const OrderAction = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
  width: 100%;
  > div {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
    border-top: 1px solid #f3f3f3;
    padding-top: 15px;
    Button {
      margin-left: 14px;
      text-transform: capitalize;
      font-size: 14px;
      line-height: 1.42857;
      padding: 6px 12px;
      text-align: center;
      white-space: nowrap;
      font-weight: normal;
      background-color: #d43f3a;
      color: #fff;
      :first-child {
        margin-left: 0;
      }
      :hover {
        opacity: 0.8;
        background-color: #d43f3a;
      }
    }
  }
`;

const MachineStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-weight: 800;
`;

export {
  Container,
  Wrapper,
  Heading,
  Panel,
  OrderInfo,
  Status,
  OrderAction,
  MachineStatusWrapper,
};
